import React from 'react';
import { AlarmClockIcon } from 'lucide-react';
type NoticeBarProps = {
  compact?: boolean;
  rounded?: boolean;
};
export function NoticeBar({
  compact = false,
  rounded = false
}: NoticeBarProps) {
  return <div role="note" className={`se-shimmer relative w-full overflow-hidden bg-gold ${rounded ? 'rounded-card shadow-soft' : ''}`} data-id="element-114" data-mp="2wfcdsqd87ngd">
      <p className={`relative z-10 mx-auto flex max-w-3xl items-center justify-center gap-3 px-4 text-center font-bold text-purple-deep ${compact ? 'py-3 text-xs sm:text-sm' : 'py-4 text-sm sm:py-5 sm:text-base'}`} data-id="element-115" data-mp="317n9fh0xon34">
        <AlarmClockIcon className={`se-tick shrink-0 ${compact ? 'h-5 w-5' : 'h-6 w-6 sm:h-7 sm:w-7'}`} aria-hidden="true" data-id="element-116" data-mp="3a8v8407d3pxq" />
        <span data-id="element-117" data-mp="3k4y7wzeqrchi">Order before 12pm today, get it delivered tomorrow. Minimum order ₦30,000.</span>
      </p>
    </div>;
}